import { useEffect, useState, type RefObject } from 'react';
import {
  computeMelodyCellSizeForMeasures,
  type MelodyPlayGrid,
} from '../utils/melodyMeasureLayout';
import { MELODY_MEASURES_SHIFT, MELODY_MEASURES_VISIBLE } from '../utils/measurePages';

const DEFAULT: MelodyPlayGrid = {
  cols: MELODY_MEASURES_VISIBLE,
  rows: 1,
  visible: MELODY_MEASURES_VISIBLE,
  shift: MELODY_MEASURES_SHIFT,
};

/** Calcula tamaño de celda para que quepan exactamente 2 compases en el lienzo. */
export function useMelodyTwoMeasureLayout(
  viewportRef: RefObject<HTMLElement | null>,
  appRef: RefObject<HTMLElement | null>,
  enabled: boolean,
): MelodyPlayGrid & { cellSize: number } {
  const [cellSize, setCellSize] = useState(46);

  useEffect(() => {
    if (!enabled) return;

    const viewport = viewportRef.current;
    const app = appRef.current;
    if (!viewport || !app) return;

    const measure = () => {
      const next = computeMelodyCellSizeForMeasures(
        viewport.clientWidth,
        viewport.clientHeight,
        MELODY_MEASURES_VISIBLE,
      );
      setCellSize(next);
      app.style.setProperty('--melody-cell-size', `${next}px`);
    };

    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(viewport);
    ro.observe(app);
    window.addEventListener('resize', measure);

    return () => {
      ro.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, [enabled, viewportRef, appRef]);

  return { ...DEFAULT, cellSize };
}
